<div class="date-range-picker">
  @if ({ periodHistory: periodHistory$ | async }; as data) {
    <div class="calendar" id="dropdown-calendar">
      @if (data.periodHistory.length > 1) {
        <div class="back">
          <a (click)="back()">
            <fa-icon [icon]="['fas', 'undo']"></fa-icon>
          </a>
        </div>
      }
      @if (period$ | async; as period) {
        <div
          class="period"
          [suiPopoverTrigger]="rangePopover"
          [suiPopoverPlacement]="!isRtl ? 'bottom-end' : 'bottom-start'"
        >
          <fa-icon [icon]="['far', 'calendar']"></fa-icon>
          @if (relativeLabel(periodPreset$ | async); as label) {
            <span class="period-relative">{{ label }}</span>
            <span class="period-absolute">
              {{ period.startTimestamp * 1000 | date: displayFormat }}
              -
              {{ period.endTimestamp * 1000 | date: displayFormat }}
            </span>
          } @else {
            <span>{{
              period.startTimestamp * 1000 | date: displayFormat
            }}</span>
            -
            <span>{{ period.endTimestamp * 1000 | date: displayFormat }}</span>
          }
          @if (lockPeriod && (isPeriodLocked$ | async)) {
            <fa-icon
              class="period-lock-icon"
              [icon]="['fas', 'lock']"
              [suiTooltip]="
                'date-range-picker.tooltip.period-is-locked' | translate
              "
            ></fa-icon>
          }
          <fa-icon [icon]="['fas', 'caret-down']"></fa-icon>
        </div>
      }
      @if ((isDefaultPeriod$ | async) == false) {
        <div
          class="cancel"
          [suiTooltip]="'date-range-picker.tooltip.button.cancel' | translate"
        >
          <a (click)="applyDefaultPeriod()">
            <fa-icon [icon]="['far', 'calendar-xmark']"></fa-icon>
          </a>
        </div>
      }
    </div>
  }
  <ng-template #rangePopover>
    <div
      suiPopover
      aria-labelledby="dropdown-calendar"
      class="dropdown-calendar dropdown-menu"
      [class.is-dashboard]="context === NomObjectClass.DASHBOARD"
    >
      <div class="header">
        <div class="title">
          {{ "date-range-picker.header.select-date-time-range" | translate }}
        </div>
        <div class="close">
          <sui-button
            size="sm"
            variant="danger"
            shape="round"
            [leadingIcon]="['fas', 'times']"
            [iconOnly]="true"
            [ariaLabel]="'btn.close' | translate"
            (click)="cancel()"
          ></sui-button>
        </div>
      </div>
      <div class="range-picker">
        @if (companyBounds$ | async; as bounds) {
          <app-date-range-selection
            [fromDate]="fromDate"
            [toDate]="toDate"
            [minDate]="bounds.min"
            [maxDate]="bounds.max"
            [timePresetBar]="timePresetBar"
            [timePresets]="timePresets"
            [activePreset]="panelPreset"
            (dateRangeSelection)="onDateRangeSelection($event)"
          >
            <app-period-history
              range-panel-extras
              [periods]="periodsHistory"
              (periodSelected)="onHistoryPeriodSelected($event)"
              (periodRemoved)="onHistoryPeriodRemoved($event)"
            ></app-period-history>
          </app-date-range-selection>
        }
      </div>
      <div
        class="footer"
        [class.dashboard-context]="context === NomObjectClass.DASHBOARD"
      >
        @if (context === NomObjectClass.DASHBOARD) {
          <sui-button variant="primary" (click)="applyToDashboardAndAllPages()">
            {{
              "date-range-picker.button.apply-to-dashboard-and-all-pages"
                | translate
            }}
          </sui-button>
        }

        <div class="right-section">
          @if (lockPeriod) {
            <div class="lock-period">
              <sui-checkbox
                [(ngModel)]="isPeriodLocked"
                [ngModelOptions]="{ standalone: true }"
              >
                {{ "date-range-picker.label.lock-period" | translate }}
              </sui-checkbox>
              <fa-icon [icon]="['fas', 'lock']"></fa-icon>
            </div>
          }

          <sui-button variant="secondary" (click)="cancel()">
            {{ "date-range-picker.button.cancel" | translate }}
          </sui-button>
          <sui-button variant="primary" (click)="applyDateRange()">
            {{ "date-range-picker.button.apply" | translate }}
          </sui-button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
